import ResourceStore from '../../../shared/services/ResourceStore';
import CompanyStore from '../Company/CompanyStore';

class EmpowermentStore extends ResourceStore {
  _baseUrl (params) {
    return `/api/v4/companies/${CompanyStore.currentCompany.id}`;
  }

  async fetchAllRights () {
    let response = await fetch(`/api/v4/companies/all_rights`);
    let responseJSON = await response.json();

    return responseJSON.all_rights;
  }
}

export default new EmpowermentStore('empowerment');
